import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';

import { useUpdateTileMutation } from './hooks/useTileMutation.jsx';
import Button from '../../../../shared/Button';
import { useToggleStatus } from './hooks/useToggleStatus.jsx';

function Undo({
  tileId,
  handleClose,
  tileHeadline,
  campaignId,
  message,
  status,
  postStatus,
}) {
  const { t } = useTranslation('tiles');

  const { toggle } = useToggleStatus({
    postStatus,
    tileStatus: status,
  });

  const { updateTileMutation } = useUpdateTileMutation({
    tileHeadline,
    campaignId,
  });

  const updateStatus = () => {
    updateTileMutation({ tileId, tileStatus: toggle });
    handleClose();
  };

  return (
    <div>
      <Text variant="small2">{message}</Text>
      <Button
        width="100px"
        height="40px"
        onClick={updateStatus}
        mode="outline"
        variant="grey"
        mt="12px"
      >
        {t('tileCardMenu.undo')}
      </Button>
    </div>
  );
}

export default Undo;
